import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { CrmProvider } from "@/lib/crm";
import { Nav } from "@/components/Nav";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Pipeline from "@/pages/Pipeline";
import Liste from "@/pages/Liste";
import Account from "@/pages/Account";
import Clienti from "@/pages/Clienti";
import Portfolio from "@/pages/Portfolio";
import Programmazione from "@/pages/Programmazione";
import Materiali from "@/pages/Materiali";
import Controllo from "@/pages/Controllo";
import Collaboratori from "@/pages/Collaboratori";
import ModelloOperativo from "@/pages/ModelloOperativo";
import Listino from "@/pages/Listino";
import Impostazioni from "@/pages/Impostazioni";
import Progetti from "@/pages/Progetti";
import Agenda from "@/pages/Agenda";
import Guida from "@/pages/Guida";

function Shell() {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen flex items-center justify-center text-slate-400">Caricamento…</div>;
  if (!user) return <Login />;
  return (
    <CrmProvider>
      <Nav />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/pipeline" element={<Pipeline />} />
          <Route path="/liste" element={<Liste />} />
          <Route path="/account" element={<Account />} />
          <Route path="/clienti" element={<Clienti />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/programmazione" element={<Programmazione />} />
          <Route path="/materiali" element={<Materiali />} />
          <Route path="/controllo" element={<Controllo />} />
          <Route path="/collaboratori" element={<Collaboratori />} />
          <Route path="/modello" element={<ModelloOperativo />} />
          <Route path="/listino" element={<Listino />} />
          <Route path="/impostazioni" element={<Impostazioni />} />
          <Route path="/progetti" element={<Progetti />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/guida" element={<Guida />} />
        </Routes>
      </main>
    </CrmProvider>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
